<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg">
            <button
              type="button"
              class="btn-list-action rounded-l-md"
              @click="emit('preview', row)"
            >
              <PlayIcon class="mr-2 h-3 text-slate-400" />
              Preview
            </button>

            <button
              v-if="!row.isActive"
              type="button"
              class="btn-list-action"
              @click="emit('enable', row)"
            >
              <EyeIcon class="mr-2 h-3 text-slate-400" />
              Enable banner
            </button>

            <button
              v-else
              type="button"
              class="btn-list-action"
              @click="emit('disable', row)"
            >
              <EyeSlashIcon class="mr-2 h-3 text-slate-400" />
              Disable banner
            </button>

            <router-link
              :to="`/banner/${row.id}`"
              class="btn-list-action"
            >
              <PencilSquareIcon class="mr-2 h-3 text-slate-400" />
              Edit
            </router-link>

            <button
              type="button"
              class="btn-list-action rounded-r-md"
              @click="emit('delete', row)"
            >
              <TrashIcon class="mr-2 h-3 text-slate-400" />
              Delete
            </button>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { ref, watch } from 'vue';
import { OnClickOutside } from '@vueuse/components';
import { EllipsisHorizontalIcon, PencilSquareIcon, EyeIcon, EyeSlashIcon, PlayIcon, TrashIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  row: {
    type: Object,
    default: () => {}
  },
  index: {
    type: Number,
    default: null
  },
  isRowHovered: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'enable', 'disable', 'preview', 'delete' ]);

const isOpened = ref(false);

watch(
  () => props.isRowHovered,
  val => (isOpened.value = val)
);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}
</script>
